export default class ScrollService {

    doSmoothScrollTo(id, distance = 0) {
        $('html, body').animate({
            scrollTop: $(`${id}`).offset().top - distance
        }, 500);
    }

    doSmoothScrollToFromModal(offset, distance = 0) {
        $('.v--modal-background-click').animate({
            scrollTop: offset - distance
        }, 500);
    }

}



// WEBPACK FOOTER //
// ./resources/site/js/providers/scroll.js